var React = require('react');

function Database (props) {
    return React.createElement("svg",props,[React.createElement("ellipse",{"cx":"12","cy":"5","rx":"9","ry":"3","key":0}),React.createElement("path",{"d":"M21 12c0 1.66-4 3-9 3s-9-1.34-9-3","key":1}),React.createElement("path",{"d":"M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5","key":2})]);
}

Database.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","className":"feather feather-database"};

module.exports = Database;

Database.default = Database;
